/* eslint-disable sonarjs/no-useless-catch */

import axios from 'axios';
import { CONFIG_KEYS, configKey, JOURNEY_ID } from './constant';
import { getJwtToken } from '../api';
import { Brands } from '@cbbt/lui-idv';

// Function to fetch and store config data in session storage
export const fetchAndStoreConfig = async (
  configUrl: string,
  configStorageVariable: string,
): Promise<any> => {
  try {
    const response = await axios.get(configUrl);
    const configData = await response?.data;
    // Store the config data in session storage
    sessionStorage.setItem(configStorageVariable, JSON.stringify(configData));
    return configData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchConfig = (key: string): Record<string, string> =>
  JSON.parse(sessionStorage.getItem(key));

export const getSessionItem = (key: string): string =>
  sessionStorage.getItem(key);

export const setSessionItem = (key: string, value: string): void => {
  const storageValue = getSessionItem(key);
  if (storageValue === undefined || storageValue === null) {
    sessionStorage.setItem(key, value);
  }
};

export const getConfigValue = (key: string): string =>
  fetchConfig(configKey)?.[key];

export const getRedirectURI = (): string =>
  `${getConfigValue(CONFIG_KEYS.smsRedirectEndpoint)}`;

export const getJwtTokenCallback = async (): Promise<any> => {
  const body = {
    journeyId: JOURNEY_ID,
    brand:
      (window as any).appConfig.BRAND_NAME === 'bos' ? Brands.BOS : Brands.LTB,
  };
  const response = await getJwtToken(body);
  return response.data;
};
